import { BaseService } from '@/core/base-service';

export default class QuestionAdminService extends BaseService<any> {
  public constructor() {
    super('services/serviceauttech/api/admin/question');
  }
}
